import { useEffect, useState } from "react";
import { MESSAGE } from "Common";
import { useNavigate, useParams } from "react-router-dom";
import inventoryApi from "api/inventoryApi";

export const useInvGoodsDetails = () => {
    const { id } = useParams();
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState({});
    const [invGoods, setInvGoods] = useState(null);
    const [reload, setReload] = useState(false);
    const [mGoods, setMGoods] = useState(null);

    const navigate = useNavigate();


    //search site
    useEffect(() => {
        (async function GetInvGoods() {
            if (!id) return;
            try {
                setIsLoading(true);

                /**Call Api */
                const dtResponse = await inventoryApi.getInventoryGoodsInfo({
                    id
                });
                const dt = dtResponse?.data?.invGoods ?? null;
                setInvGoods(dt);
            } catch (err) {
                const msg = {
                    contents: [err],
                    type: MESSAGE.ERROR
                }
                setMessage(msg);
            } finally {
                setIsLoading(false);
            }
        })()
    }, [id, reload]);

    const handleDeleteInvHistory = async (invHistory) => {
        if (!invHistory || !invHistory.ClientInventoryHistoryID) return;
        try {
            setIsLoading(true);

            /**Call Api */
            await inventoryApi.deleteInventoryHistory({
                id: invHistory.ClientInventoryHistoryID
            });
            setReload(!reload);
        }
        catch (err) {
            const msg = {
                contents: [err],
                type: MESSAGE.ERROR
            }
            setMessage(msg);
        }
        finally {
            setIsLoading(false);
        }
    }

    const handleDeleteInvGoods = async (invGoods) => {
        if (!invGoods || !invGoods.ClientInventoryGoodsID) return;
        try {
            setIsLoading(true);

            /**Call Api */
            const res = await inventoryApi.deleteInventoryGoods({
                id: invGoods.ClientInventoryGoodsID
            });
            if (!!res?.data?.msg) {
                const msg = {
                    contents: [res.data.msg],
                    type: MESSAGE.ERROR
                }
                setMessage(msg);
                setReload(!reload);
            } else {
                const msg = {
                    contents: ["在庫データ削除が完了しました"],
                    type: MESSAGE.INFO,
                    handleClose: () => { navigate(`/inventory`, { replace: true }); }
                }
                setMessage(msg);
            }

        }
        catch (err) {
            const msg = {
                contents: [err],
                type: MESSAGE.ERROR
            }
            setMessage(msg);
        }
        finally {
            setIsLoading(false);
        }
    }

    return {
        navigate, isLoading, setIsLoading
        , setReload, message, setMessage
        , invGoods, mGoods, setMGoods
        , handleDeleteInvHistory
        , handleDeleteInvGoods
    };

}